module.exports = __webpack_public_path__ + "img/straight.1948d044.svg";